import { useContext } from "react";
import { OrganisationContext } from "@RequestFormV2/sections/Organisation/context/OrganisationProvider";

export function useOrganisation() {
  const context = useContext(OrganisationContext);
  if (!context) {
    throw new Error("useOrganisation must be used within an OrganisationProvider");
  }
  return context;
}
